import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/OGPhase10"; 

const OGPhase10 = () => {
  const projectId = "PRJ00041";
  const title = "Oasis Garden Phase 10";

  const mapConfig = {
    minZoom: 14,
    zoom: 15,
    
    bounds: [
      [-1.336, 36.575],
      [-1.385, 36.601],
    ],
    imageOverlays: [],
    styleConfig: {
      mode: "plot_status",
      sizeField: "plot_size",
    },
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/the-great-oasis-gardens-nanyuki/"
      fillOfferLink="https://forms.gle/hxLRYUAPwsV296nt7"
    />
  );
};

export default OGPhase10;
